<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <label for="" class="vs-input--label">Component source</label>

        <v-select v-model="reader_data.component_source"
          :options="[{ id: 0, label: 'ACU', disabled: isFloor ? true : false }]" class="select_padding w-full"
          name="status" placeholder="Component source" :reduce="(source) => source.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>

      <div class="vx-col w-1/2 mt-3">
        <label for="" class="vs-input--label">Condition</label>

        <v-select v-model="reader_data.condition" :options="conditions" class="select_padding w-full" name="status"
          placeholder="Condition" :reduce="(source) => source.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>

      <div class="vx-col w-1/2 mt-3">
        <label for="" class="vs-input--label">Inputs</label>

        <v-select v-model="reader_data.input" :options="inputs" class="select_padding w-full" name="status"
          placeholder="Input" :reduce="(source) => source.id" :dir="$vs.rtl ? 'rtl' : 'ltr'"
          :selectable="(option) => !option.disabled" :disabled="reader_data.component_source == null" />
      </div>

      <div class="vx-col w-full mt-3">
        <vs-input label="Name" class="w-full" name="name" disabled v-model="reader_data.name" />
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { checkInput } from "@/functions/checkInputOutput";

export default {
  data() {
    return {
      inputs: [],
      reader_data: {},
    };
  },
  watch: {
    reader_data: {
      handler: function (reader_data, oldData) {
        this.$store.commit("accessPoint/SET_READER_DATA", {
          data: { ...reader_data },
        });
      },
      deep: true,
    },
    active_reader(data) {
      const reader_data =
        this.access_points[this.active_point].readers[this.active_reader];

      if (reader_data.reader_info) {
        this.reader_data = { ...reader_data.reader_info };
      } else {
        this.initValues();
        this.reader_data.name = reader_data.name;
      }

      this.setInputs();
    },
    acuModel() {
      this.setInputs();
    },
  },
  computed: {
    active_reader() {
      return this.$store.state.accessPoint.active_reader;
    },
    active_point() {
      return this.$store.state.accessPoint.active_point;
    },
    access_points() {
      return this.$store.state.accessPoint.acu_data.access_points;
    },
    componentsources() {
      return this.$store.state.accessPoint.componentsources;
    },
    relay_modes() {
      return this.$store.state.accessPoint.relay_modes;
    },

    lock_types() {
      return this.$store.state.accessPoint.lock_types;
    },
    acuModel() {
      return this.$store.state.accessPoint.acu_data.model;
    },
    acu_model() {
      return this.$store.state.accessPoint.acu_model.controllers;
    },
    conditions() {
      return this.$store.state.accessPoint.conditions;
    },
    isFloor() {
      let model = this.acuModel;
      let elevator_mode = this.$store.state.accessPoint.acu_data.elevator_mode;

      if ((model == "Icon" || model == "Icon-PRO") && elevator_mode) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    checkNumber(value, field) {
      let result = +value.replace(/[^+0-9]/g, "");

      if (field === "impulse_time") {
        result = value.replace(/[^\d.]|\.(?=.*\.)/g, "");
        if (result > 2) {
          this.reader_data.impulse_time = 2;
        } else {
          let filtered = 0;
          if (result.slice(-1) === ".") {
            filtered = result;
          } else {
            let res = +result;

            let isDecimal = +res % 1;

            if (isDecimal !== 0) {
              filtered = +res.toFixed(1);
            } else {
              filtered = res;
            }
          }

          this.reader_data.impulse_time = filtered;
        }
      } else {
        if (field === 'entry_exit_open_durations' && value > 60) {
          this.reader_data[field] = 60
        } else {
          this.reader_data[field] = result;
        }
      }
    },
    setInputs(value) {
      const data = this.$store.state.accessPoint.acu_data;
      const access_points = data.access_points;
      this.inputs = [];
      const resources = checkInput(access_points, this.active_reader);

      let input_arr = [];
      if (data.model) {
        this.acu_model[data.model].inputs;
        for (let i = 1; i <= this.acu_model[data.model].inputs; i++) {
          if (resources.includes(i)) {
            input_arr.push({ id: i, label: i, disabled: true });
          } else {
            input_arr.push({ id: i, label: i });
          }
        }
        this.inputs = input_arr;
        if (value !== "changed") {
          this.reader_data.input = input_arr[0].id;
        }
      }
    },
    initValues() {
      this.reader_data = {
        component_source: null,
        name: null,
        output: null,
        relay_mode: this.relay_modes[0].id,
        type: this.lock_types[0].id,
        entry_exit_open_durations: null,
        door_sensor_autolock: false,
        impulse_time: 0,
      };
    },
    changeComponentSource() {
      const data = this.$store.state.accessPoint.edit_acu_data;
      const resources = checkOutputArr(data, this.active_reader, true);

      if (this.reader_data.component_source !== 0) {
        const dev = this.extDevice.find(
          i => i.id === this.reader_data.component_source
        );
        let device;
        let input_arr = [];
        if (dev && dev.ext_board) {
          if(dev.ext_board == "AIR-R"){
            device=this.expansion_boards.reader_board["AIR-R"]
          }else if (dev.ext_board == "REX-16") {
            device = this.expansion_boards.relay_board["REX-16"];
            this.reader_data.relay_mode = dev.relay_mode;
            this.reader_data.impulse_time = dev.impulse_time;
            this.reader_data.entry_exit_open_durations = dev.open_duration;
          } else if (dev.ext_board == "IEX-16") {
            device = this.expansion_boards.alarm_board["IEX-16"];
            this.reader_data.condition = dev.condition;
          }
        }
        if (device.outputs) {
          for (let i = 1; i <= device.outputs; i++) {
            if (resources.includes(i)) {
              input_arr.push({ id: i, label: i, disabled: true });
            } else {
              input_arr.push({ id: i, label: i });
            }
          }
        }
        this.inputs = input_arr;
        if (data.model === "Icon" || data.model === "Icon-PRO") {
          this.type_outputs = "outputs_info_ext";
        } else {
          this.type_outputs = "outputs";
        }
        this.only_blue = false;
        // this.reader_data.output = input_arr[0].id;
      } else {
        this.setInputs();
      }
    },
  },
  created() {
    const reader_data =
      this.access_points[this.active_point].readers[this.active_reader];
    this.initValues();
    this.setInputs();

    this.reader_data.name = reader_data.name;
  },
  components: {
    vSelect,
  },
};
</script>